<template>
    <div class="container-fluid">
        <div class="row mb-3">
            <div class="col">
                <div class="mb-1 d-block">
                    <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" name="type" id="bulan" v-model="type"
                               value="bulan">
                        <label class="form-check-label" for="bulan">Bulan</label>
                    </div>
                    <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" name="type" id="tarikh" v-model="type"
                               value="tarikh">
                        <label class="form-check-label" for="tarikh">Tarikh</label>
                    </div>
                </div>
                <div class="d-inline-block">
                    <div class="d-flex mb-3" v-if="type ==='tarikh'">
                        <VueDatePicker v-model="dateFrom" :auto-position="true"
                                       :time-config="{ enableTimePicker: false }" :formats="{ input: 'dd-MMM-yyyy', preview: 'dd-MMM-yyyy' }" week-start="0" :locale="ms"
                                       :format-locale="ms" style="max-width: 250px"
                                       placeholder="Tarikh mula" select-text="Pilih" cancel-text="Tutup"
                                       class="d-inline-block me-2"></VueDatePicker>
                        <span class="d-inline-block me-2 my-1">hingga</span>
                        <VueDatePicker v-model="dateTo" :auto-position="true"
                                       :time-config="{ enableTimePicker: false }" :formats="{ input: 'dd-MMM-yyyy', preview: 'dd-MMM-yyyy' }" week-start="0" :locale="ms"
                                       :format-locale="ms" style="max-width: 250px"
                                       placeholder="Tarikh akhir" select-text="Pilih" cancel-text="Tutup"
                                       class="d-inline-block"></VueDatePicker>
                    </div>
                </div>
                <div class="d-inline-block mb-3" v-if="type ==='bulan'">
                    <select class="form-select d-inline-block" style="width: 80px" v-model="monthSelected">
                        <option v-for="m in monthRange" :value="m" class="text-center">{{ m }}</option>
                    </select>
                    <select class="form-select d-inline-block" style="width: 100px" v-model="yearSelected">
                        <option v-for="y in yearRange" :value="y" class="text-center">{{ y }}</option>
                    </select>
                </div>
                <button type="button" class="btn btn-primary ms-2 d-inline-block" :disabled="(dateFrom ===  null && dateTo === null) && type === 'tarikh'"
                        @click="getData()"><font-awesome-icon :icon="faMagnifyingGlass" class="me-2"/>Cari
                </button>
                <div class="form-check form-check-inline ms-2">
                    <input class="form-check-input" type="checkbox" id="pejabatLama" value="old" v-model="olderOffice">
                    <label class="form-check-label" for="pejabatLama">Pejabat lama</label>
                </div>
                <form v-if="reportData.daerahPewakafPejabat.length > 0" :action="uri_download_report_kaunter_daerah_pewakaf" method="post" class="d-inline-block">
                    <input type="hidden" name="_token" :value="csrf">
                    <input type="hidden" v-if="olderOffice !== undefined" name="wantOld" :value="(olderOffice)?1:0">
                    <input type="hidden" v-if="type === 'bulan'" name="month" :value="monthSelected">
                    <input type="hidden" v-if="type === 'bulan'" name="year" :value="yearSelected">
                    <input type="hidden" v-if="type === 'tarikh' && dateFrom !== null" name="from" :value="parseDateData(dateFrom)">
                    <input type="hidden" v-if="type === 'tarikh' && dateTo !== null" name="to" :value="parseDateData(dateTo)">
                    <button type="submit" :disabled="(dateFrom ===  null && dateTo === null) && type === 'tarikh'" class="btn btn-outline-success fs-6 d-inline-block" ><font-awesome-icon :icon="faFileExcel" class="me-2" />Muat turun laporan</button>
                </form>
                <button type="button" class="btn btn-warning ms-2 float-end d-inline-block"
                        @click="goBack">
                    <font-awesome-icon :icon="faChevronLeft" /> Kembali
                </button>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="wrapper" ref="wrapper">
                    <table v-if="reportData.daerahPewakafPejabat.length > 0" class="table table-striped-columns">
                        <thead class="table-dark">
                        <tr>
                            <th class="text-center align-middle" style="width: 5px;" rowspan="3">Bil</th>
                            <th class="text-center align-middle" rowspan="3">Kaunter / Pejabat</th>
                            <th class="text-center" :colspan="reportData.daerahPewakaf.length*2">Daerah</th>
                            <th class="text-center align-middle" colspan="2" rowspan="2">Jumlah</th>
                        </tr>
                        <tr>
                            <th v-for="district in reportData.daerahPewakaf" colspan="2" class="text-center">{{ district }}</th>
                        </tr>
                        <tr>
                            <template v-for="monthh in reportData.daerahPewakaf">
                                <th>Bil</th>
                                <th>Amaun</th>
                            </template>
                            <th>Bil</th>
                            <th>Amaun</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(kaunter,index) in reportData.daerahPewakafPejabat">
                            <td class="text-white fw-bold">{{ index+1 }}</td>
                            <td class="text-white fw-bold">{{ kaunter.Office }}</td>
                            <td class="text-end">{{ sumFormatWithoutDecimal(kaunter.KuantanBil) }}</td>
                            <td class="text-end">{{ sumFormatWithoutCurrency(kaunter.KuantanAmaun) }}</td>
                            <td class="text-end">{{ sumFormatWithoutDecimal(kaunter.PekanBil) }}</td>
                            <td class="text-end">{{ sumFormatWithoutCurrency(kaunter.PekanAmaun) }}</td>
                            <td class="text-end">{{ sumFormatWithoutDecimal(kaunter.TemerlohBil) }}</td>
                            <td class="text-end">{{ sumFormatWithoutCurrency(kaunter.TemerlohAmaun) }}</td>
                            <td class="text-end">{{ sumFormatWithoutDecimal(kaunter.RompinBil) }}</td>
                            <td class="text-end">{{ sumFormatWithoutCurrency(kaunter.RompinAmaun) }}</td>
                            <td class="text-end">{{ sumFormatWithoutDecimal(kaunter.MaranBil) }}</td>
                            <td class="text-end">{{ sumFormatWithoutCurrency(kaunter.MaranAmaun) }}</td>
                            <td class="text-end">{{ sumFormatWithoutDecimal(kaunter.BentongBil) }}</td>
                            <td class="text-end">{{ sumFormatWithoutCurrency(kaunter.BentongAmaun) }}</td>
                            <td class="text-end">{{ sumFormatWithoutDecimal(kaunter.KualaLipisBil) }}</td>
                            <td class="text-end">{{ sumFormatWithoutCurrency(kaunter.KualaLipisAmaun) }}</td>
                            <td class="text-end">{{ sumFormatWithoutDecimal(kaunter.CamHighlandsBil) }}</td>
                            <td class="text-end">{{ sumFormatWithoutCurrency(kaunter.CamHighlandsAmaun) }}</td>
                            <td class="text-end">{{ sumFormatWithoutDecimal(kaunter.JerantutBil) }}</td>
                            <td class="text-end">{{ sumFormatWithoutCurrency(kaunter.JerantutAmaun) }}</td>
                            <td class="text-end">{{ sumFormatWithoutDecimal(kaunter.JengkaBil) }}</td>
                            <td class="text-end">{{ sumFormatWithoutCurrency(kaunter.JengkaAmaun) }}</td>
                            <td class="text-end">{{ sumFormatWithoutDecimal(kaunter.RaubBil) }}</td>
                            <td class="text-end">{{ sumFormatWithoutCurrency(kaunter.RaubAmaun) }}</td>
                            <td class="text-end">{{ sumFormatWithoutDecimal(kaunter.LuarPahangBil) }}</td>
                            <td class="text-end">{{ sumFormatWithoutCurrency(kaunter.LuarPahangAmaun) }}</td>
                            <td class="text-end">{{ sumFormatWithoutDecimal(kaunter.ChenorBil) }}</td>
                            <td class="text-end">{{ sumFormatWithoutCurrency(kaunter.ChenorAmaun) }}</td>
                            <td class="text-end">{{ sumFormatWithoutDecimal(kaunter.BeraBil) }}</td>
                            <td class="text-end">{{ sumFormatWithoutCurrency(kaunter.BeraAmaun) }}</td>
                            <td class="text-end">{{ sumFormatWithoutDecimal(kaunter.MuadzamShahBil) }}</td>
                            <td class="text-end">{{ sumFormatWithoutCurrency(kaunter.MuadzamShahAmaun) }}</td>
                            <td class="text-end">{{ sumFormatWithoutDecimal(kaunter.TiomanBil) }}</td>
                            <td class="text-end">{{ sumFormatWithoutCurrency(kaunter.TiomanAmaun) }}</td>
                            <td class="table-dark fw-bold text-end">{{ sumFormatWithoutDecimal(kaunter.TotalBil) }}</td>
                            <td class="table-dark fw-bold text-end">{{ sumFormatWithoutCurrency(kaunter.TotalAmaun) }}</td>
                        </tr>
                        </tbody>
                        <tfoot>
                            <tr>
                                <td class="border-right-0"></td>
                                <td class="text-center fw-bold text-white">Jumlah</td>
                                <td v-for="(grandSumInQue,index) in reportData.totalByDistrics" class="table-dark fw-bold text-end">{{ (index%2 === 0)? sumFormatWithoutDecimal(grandSumInQue) : sumFormatWithoutCurrency(grandSumInQue) }}</td>
                                <td class="table-dark fw-bold text-end">{{ sumFormatWithoutDecimal(reportData.grandSumBilTotal) }}</td>
                                <td class="table-dark fw-bold text-end">{{ sumFormatWithoutCurrency(reportData.grandSumAmaunTotal) }}</td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import {onMounted, ref} from "vue";
import {arrayMonth, arrayYear, sumFormatWithoutCurrency, sumFormatWithoutDecimal, parseDateData} from "../../utils/utils";
import axios, {AxiosError} from "axios";
import Swal from "sweetalert2";
import { VueDatePicker } from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import { ms } from "date-fns/locale";
import { formatISO } from "date-fns";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import {faChevronLeft, faFileExcel, faMagnifyingGlass} from "@fortawesome/free-solid-svg-icons";
library.add(faChevronLeft);
library.add(faFileExcel);
library.add(faMagnifyingGlass);

const data = defineProps<{
    uri_get_kaunter_daerah: string,
    uri_download_report_kaunter_daerah_pewakaf: string,
    year: number,
    month: number,
    csrf: string,
}>();

const type = ref<string>("bulan");
const yearRange = ref<number[]>();
const monthRange = ref<number[]>();
const dateFrom = ref<string|null>(null);
const dateTo = ref<string|null>(null);

const yearSelected = ref<number>();
const monthSelected = ref<number>();
const reportData = ref<{
    grandSumAmaunTotal: number,
    grandSumBilTotal: number,
    daerahPewakaf: string[],
    totalByDistrics: number[],
    daerahPewakafPejabat: {
        BentongAmaun: number,
        BentongBil: number,
        BeraAmaun: number,
        BeraBil: number,
        CamHighlandsAmaun: number,
        CamHighlandsBil: number,
        ChenorAmaun: number,
        ChenorBil: number,
        IbuPejabatTotalAmaun: number,
        IbuPejabatTotalBil: number,
        JengkaAmaun: number,
        JengkaBil: number,
        JerantutAmaun: number,
        JerantutBil: number,
        KualaLipisAmaun: number,
        KualaLipisBil: number,
        KuantanAmaun: number,
        KuantanBil: number,
        LuarPahangAmaun: number,
        LuarPahangBil: number,
        MaranAmaun: number,
        MaranBil: number,
        MuadzamShahAmaun: number,
        MuadzamShahBil: number,
        TiomanAmaun: number,
        TiomanBil: number,
        Office: string,
        PekanAmaun: number,
        PekanBil: number,
        RaubAmaun: number,
        RaubBil: number,
        RompinAmaun: number,
        RompinBil: number,
        TemerlohAmaun: number,
        TemerlohBil: number,
        TotalAmaun: number,
        TotalBil: number,
    }[],
}>({
    grandSumAmaunTotal: 0,
    grandSumBilTotal: 0,
    daerahPewakaf: [],
    totalByDistrics: [],
    daerahPewakafPejabat: []
});

const wrapper = ref<HTMLDivElement>();
const olderOffice = ref<boolean>();

const emitToParent = defineEmits<{
    (e: "hidePage", flag: boolean): void,
    (e: "hideLoader"): void,
    (e: "showLoader"): void,
}>()

onMounted(() => {
    yearRange.value = arrayYear(data.year);
    monthRange.value = arrayMonth();
    yearSelected.value = data.year;
    monthSelected.value = data.month;
    getData();
    setTimeout(()=>{
        if (wrapper.value) {
            wrapper.value.style.height = `calc(100svh - ${window.scrollY + wrapper.value?.getBoundingClientRect()?.top + 20}px)` ; //.getBoundingClientRect()?.top
        }
    },1000)
});

let getData = () => {
    emitToParent("showLoader");
    let postData: {
        csrf: string,
        month?: number,
        year?: number,
        from?: string,
        to?: string,
        wantOld?: number
    } = {
        csrf: data.csrf,
    };
    if (olderOffice.value === true) {
        postData = { ... postData, wantOld: 1} ;
    }
    if (type.value === "bulan") {
        postData = { ... postData, month: monthSelected.value};
        postData = { ... postData, year: yearSelected.value};
    } else if (type.value === "tarikh") {
        if (dateFrom.value !== null) {
            postData = { ... postData, from: formatISO(new Date(dateFrom.value))};
        }
        if (dateTo.value !== null) {
            postData = { ... postData, to: formatISO(new Date(dateTo.value))};
        }
    }
    axios({
        method: "post",
        url: data.uri_get_kaunter_daerah,
        data: postData,
        headers: {"Content-Type":"application/json"}
    }).then(function (response) {
        reportData.value = response.data;
        emitToParent("hideLoader");
    }).catch(function (error: AxiosError) {
        emitToParent("hideLoader");
        Swal.fire({
            icon: "error",
            title: "Ralat berlaku",
            text: "Sila cuba semula untuk cari. " + error.request.statusText,
            timer: 3000,
            timerProgressBar: true,
            confirmButtonColor: "#0d6efd",
            confirmButtonText: "Ok",
        }).then(() => {
        })
    });
}

let goBack = () :void =>{
    emitToParent("hidePage", true);
}
</script>

<style scoped>
table {
    border-collapse: separate;
    border-spacing: 0;
}
.wrapper {
    width: 100%;
    overflow: auto;
}

.wrapper th {
    position: sticky;
    z-index: 999;
    left: 0;
}

table > thead > tr:nth-child(2) > th {
    min-width: 150px;
    height: 70px;
}

.wrapper td {
    padding: 5px;
    width: 30px;
    min-width: 30px;
}

.wrapper th:nth-child(1):not(:last-child),
.wrapper td:nth-child(1):not(:last-child) {
    position: sticky;
    left: 0;
}

.wrapper th:nth-child(2):not(:last-child),
.wrapper td:nth-child(2):not(:last-child) {
    position: sticky;
    left: 30px;
}

.wrapper td:nth-child(1):not(:last-child),
.wrapper td:nth-child(2):not(:last-child) {
    background-color: #5A1C50;
    border: 1px solid white;
}

tr:nth-child(2) > th:nth-child(n+0) {
    position: sticky;
    top: 0;
    border: 1px solid black;
}

tr:nth-child(3) > th:nth-child(n+0) {
    position: sticky;
    top: 70px;
    border: 1px solid black;
}

tr:nth-child(1) > th:nth-child(4) /* Jumlah*/
{
    position: sticky;
    top: 0;
    border: 1px solid black;
}
</style>
